import React, {useEffect, useState} from 'react';
import Header from "../components/header";
import 'react-toastify/dist/ReactToastify.css';
import {toast, ToastContainer} from "react-toastify";
import './../assets/style/modal.css';
import './../assets/style/dashboard.css';
import './../assets/style/table.css';
import {Grid} from "@mui/material";
import Sidebar from "../components/Sidebar";
import '../assets/style/adslist.css';
import { getAllExistingAds } from '../api/services';
import { useNavigate } from 'react-router-dom';
import UpdateIcon from '@mui/icons-material/Update';
import AppModal from "../components/AppModal";
import ExistingAdsUpdate from "../components/ExistingAdsUpdate";
import Download from "../components/Download";
import Loader from '../components/loader';
import '../assets/style/adslist.css';

function ExisingAdList() {
    let userData = JSON.parse(window.localStorage.getItem("userData") || "{}");
    const role = userData.role ?? "";
    
    const [ads, setAds] = useState([]);
    const [locationDetailIds, setLocationDetailIds] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [popupExistingAd, setPopupExistingAd] = useState(false);
    const [documentDownload, setDocumentDownload] = useState('');
    const [isDownloadOpen, setIsDownloadOpen] = useState(false);
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    const handleImageClick = (e) => {
        setModalImageSrc(e.target.src);
        setModalVisible(true);
    };
    const closeModal = () => {
        setModalVisible(false);
    };
    const ITEMS_PER_PAGE = 10; // change as needed
    const [currentPage, setCurrentPage] = useState(1);

    const [searchTerm, setSearchTerm] = useState('');
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const filteredAds = ads.filter(ad =>
        ad.ward_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ad.location.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
    const totalPages = Math.ceil(filteredAds.length / ITEMS_PER_PAGE);
    const paginatedAds = filteredAds.slice(startIndex, endIndex);
      
    const selectedLoction = (location_detail_id) => {
        let index = locationDetailIds.indexOf(location_detail_id);
        if (index > -1){
            setLocationDetailIds(locationDetailIds => {
                return locationDetailIds.filter((value, i) => i !== index)
            });
        }else{
            setLocationDetailIds([...locationDetailIds, location_detail_id]);
        }
    };
    const adsInit = () => {
        getAllExistingAds().then(
            response => {
                if (response.success) {
                    setAds(response.data.advertisement);
                }
                else {
                    toast.error(response.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            }
        )
    };
    useEffect(() => {
        if (window.localStorage.getItem("login")) {
            adsInit();
            setTimeout(() => {
                setIsLoading(false);
            }, 500);
        }
        else {
            navigate("/")
        }

    }, []);

    const closeExistingAd = () => {
        setPopupExistingAd(false)
    }
    
    const closePopupWard = () => {
        setIsDownloadOpen(false)
    }
    const submitAds = (pdf) => {
        adsInit();
        setIsDownloadOpen(true);
        setDocumentDownload(pdf);
        setLocationDetailIds([]);
    }
    return (
        
        <>
            <AppModal top='30'
                isOpen={popupExistingAd}
                content={<ExistingAdsUpdate dataids={locationDetailIds} closeModal={closeExistingAd} reload={submitAds} />}
            />
            <AppModal isOpen={isDownloadOpen}
                                content={<Download buttonDownload={documentDownload} closeModal={closePopupWard} />
                                }
                            />
                            
            <Header />
            <Grid container sx={{ flexGrow: 1 }}>
                <Grid item xs={0} md={2.3} xl={1.7}>
                    <Sidebar />
                </Grid>
                <Grid item xs={12} md={9.7} xl={10.3}>
                    {isLoading ? (
                                    <div style={{textAlign:"center", paddingTop: "30px"}}> <Loader /> </div>
                                ) :
                    <div className='dashboard' style={{padding: "20px 0px"}}>
                        <ToastContainer />
                        <div style={{width: "90%"}}>
                        <input
                            type="text"
                            placeholder="Search by ward or location..."
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1); // Reset to first page on search
                            }}
                            className="custom-search-input"
                            />

                            <table>
                                <thead>
                                <tr>
                                    {locationDetailIds.length === 0?<>
                                        <th width="5%"></th>
                                        <th width="25%">Ward name</th>
                                        <th width={(role === 'superadmin')?"20%":"50%"}>Location</th>
                                        { (role === 'superadmin')?
                                        <th width="30%">Image Capture Coordinates</th>
                                        :""}
                                        <th width="20%">Image</th>
                                    </>:
                                    <>
                                        <th width="5%"></th>
                                        <th  width="95%" colSpan={(role === 'superadmin')?5:4}><a href='javascript:void(0);' onClick={() => setPopupExistingAd(true)}  style={{textDecoration:'none', color: "#ffffff"}} > <UpdateIcon fontSize='small' style={{marginBottom:'-5px'}}/> <span>Update advertisement</span></a></th>
                                    </>}
                                    
                                </tr>
                                </thead>
                                <tbody>
                                {paginatedAds.length > 0 ? paginatedAds.map((row) => (
                                    <tr key={row.location_detail_id}>
                                        <td width="5%">
                                        <input type='checkbox' onClick={() => selectedLoction(row.location_detail_id)} />
                                        </td>
                                        <td width="25%">Ward {row.ward_name}</td>
                                        <td width={(role === 'superadmin')?"20%":"50%"}>{row.location}</td>
                                        { (role === 'superadmin')?
                                        <td width="30%">
                                            <a href={`https://maps.google.com/maps?q=${row.latitude},${row.longitude}&hl=es&z=14&output=embed`} target="_blank" rel="noopener noreferrer">
                                                <iframe width="160" height="120" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src={`https://maps.google.com/maps?q=${row.latitude},${row.longitude}&hl=es&z=14&output=embed`} title="Google Map" ></iframe>
                                            </a>
                                        </td>
                                         :""}
                                        <td width="20%">
                                             <img src={row.image} alt='' className="card-image" onClick={handleImageClick}/>
                                        </td>
                                    </tr>
                                    )) : (
                                    <tr>
                                        <td colSpan={(role === 'superadmin')?5:4} style={{ textAlign: 'center' }}>No record found.</td>
                                    </tr>
                                    )}

                                </tbody>
                            </table>
                            {totalPages > 1 && (
                                <nav className="custom-pagination mt-3">
                                <ul className="pagination-list">
                                  <li className={`pagination-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>&laquo; Prev</button>
                                  </li>
                              
                                  {Array.from({ length: totalPages }, (_, idx) => (
                                    <li
                                      key={idx}
                                      className={`pagination-item ${currentPage === idx + 1 ? "active" : ""}`}
                                    >
                                      <button onClick={() => setCurrentPage(idx + 1)}>{idx + 1}</button>
                                    </li>
                                  ))}
                              
                                  <li className={`pagination-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}>Next &raquo;</button>
                                  </li>
                                </ul>
                              </nav>
                              
                            )}
                            {modalVisible && (
                                <div className="modal-overlay" onClick={() => setModalVisible(false)}>
                                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                    <img src={modalImageSrc} alt="Zoomed Image" class="zoomed-image"/>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div >
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default ExisingAdList;
